import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CUSTOMER_TYPE_NAME } from '../models/enums';

@Pipe({
  name: 'customerTypeFormatter',
  pure: false,
})
export class CustomerTypeFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: CUSTOMER_TYPE_NAME | string): string {
    if (!value) {
      return value;
    }

    let resultDate = this.getResult(value);

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(value);
    });

    return resultDate;
  }

  private getResult(type: CUSTOMER_TYPE_NAME | string): string {
    return this.translateService.instant(`pipes.customer_type.${type}`);
  }
}
